module.exports = __webpack_public_path__ + "img/green-pita-08.85d7ff2b.png";